<template>
    <div>
        <b-modal size="xl" id="modal-prevent-closing" class="header-modal" no-close-on-backdrop hide-footer
            ref="modal-confirm-question-bank">
            <b-form id="form-create-update-chapter" @submit.prevent="handleSave">
                <div class="modal-confirm-question-bank">
                    <div class="row col-md-12">
                        <h4 class="title-header"><strong>Chỉnh sửa bài tập/ bài kiểm tra</strong></h4>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-lg-8">
                            <div class="text-center"><strong>Nội dung đề</strong></div>
                            <div class="wrap-left">
                                <draggable :list="form.listQuestion">
                                    <transition-group type="transition">
                                        <div class="row col-md-12" v-for="(dataSource, index) of form.listQuestion"
                                            :key="index">
                                            <div style="margin-right: 10px;" class="margin-top-10">
                                                <img class="icon-upload" width="15px"
                                                    src="@/assets/img/dots-menu.png" />
                                            </div>

                                            <div class="wrap-question-answer col-md-10">
                                                <img @click="handleDeleteQuestion(dataSource)" class="icon-delete"
                                                    src="@/assets/img/x.png" />
                                                <PreviewQuestion :id="`question_${index}`" :dataSource="dataSource"
                                                    :location="index" :questions="form.listQuestion"
                                                    :isDontShowResultSaved="true" />
                                            </div>
                                            <div class="col-md-1">
                                                <div class="display-flex">
                                                    <input @input="handleOnInputPoint($event, dataSource)"
                                                        :disabled="form.countPoint > 0 ? false : true"
                                                        v-model="dataSource.point" id="point" type="text"
                                                        placeholder="Nhập điểm" autocomplete="off"
                                                        class="form-control point-question" />
                                                    <div>điểm </div>
                                                </div>
                                                <button @click="handleEditQuestion(dataSource)"
                                                    v-if="dataSource.hasEdit" type="button"
                                                    class="btn btn-main border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1 margin-top-10"
                                                    :disabled="isLoading">
                                                    Chỉnh sửa
                                                </button>
                                            </div>
                                        </div>
                                    </transition-group>
                                </draggable>

                            </div>

                        </div>
                        <div class="col-md-12 col-lg-4">
                            <div class="text-center"><strong>Thông tin đề
                                    <img class="icon-close" src="@/assets/img/x.png" @click="handleOnClose" />
                                </strong></div>
                            <div class="row actions_question margin-10">
                                <div class="col-md-6 instruction-prepare-questions">
                                    <a href="javascript:;" @click="handleOnOpenModalInstruction">Hướng dẫn soạn câu
                                        hỏi</a>
                                </div>
                                <div class="col-md-6">
                                    <button
                                        class="btn btn-main border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1">Lấy
                                        câu hỏi từ ngân hàng câu hỏi</button>
                                </div>
                            </div>
                            <div class="row col-md-12">
                                <label for="name" class="title-label">Tên đề <span class="required">*</span>:</label>
                                <b-form-input v-model="form.name" id="name" type="text" placeholder="Nhập tên đề..."
                                    autocomplete="off" class="form-control" />
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.name.required && submitted">
                                    Vui lòng nhập tên đề
                                </span>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-xl-3 b-col-lg-6 b-col-xl-3">
                                    <label for="classId" class="title-label">Khối <span
                                            class="required">*</span>:</label>
                                    <b-form-select v-model="form.classId" :options="listDataClass" class="">
                                    </b-form-select>
                                    <span class="error display-block color-err font-size-14 text-left"
                                        v-if="!$v.form.classId.required && submitted">
                                        Vui lòng nhập khối lớp
                                    </span>
                                </div>
                                <div class="col-md-6 col-lg-6 col-xl-3 b-col-lg-6 b-col-xl-3">
                                    <label for="subjectId" class="title-label">Môn học <span
                                            class="required">*</span>:</label>
                                    <b-form-select v-model="form.subjectId" :options="listDataSubject" class="">
                                    </b-form-select>
                                    <span class="error display-block color-err font-size-14 text-left"
                                        v-if="!$v.form.classId.required && submitted">
                                        Vui lòng nhập môn học
                                    </span>
                                </div>
                                <div class="col-md-12 col-lg-8 col-xl-6">
                                    <label for="typeExcercise" class="title-label">Bài tập/bài kiểm tra <span
                                            class="required">*</span>:</label>
                                    <b-form-select v-model="form.typeExcercise" :options="listTypeExcercise" class="">
                                    </b-form-select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="minuteExcercise" class="title-label">Thời gian <span
                                            v-if="form.typeExcercise == 1" class="required">*</span>:</label>
                                    <div class="display-flex">
                                        <b-form-input :disabled="isDisabledMinute" v-model="form.minuteExcercise"
                                            id="minuteExcercise" type="number" placeholder="Nhập thời gian"
                                            autocomplete="off" class="form-control" />
                                        <div>Phút </div>
                                    </div>
                                    <span class="error display-block color-err font-size-14 text-left"
                                        v-if="!$v.form.minuteExcercise.required && submitted">
                                        Vui lòng nhập thời gian
                                    </span>
                                </div>
                                <div class="col-md-6">
                                    <label for="code" class="title-label">Mã đề:</label>
                                    <b-form-input v-model="form.code" id="code" type="text" placeholder="Nhập mã đề"
                                        autocomplete="off" class="form-control" />
                                    <!-- <span class="error display-block color-err font-size-14 text-left"
                                        v-if="!$v.form.code.required && submitted">
                                        Vui lòng nhập mã đề
                                    </span> -->
                                </div>
                            </div>
                            <div class="row col-md-12">
                                <label for="nameSchool" class="title-label">Trường:</label>
                                <b-form-input v-model="form.nameSchool" id="nameSchool" type="text"
                                    placeholder="Nhập trường" autocomplete="off" class="form-control" />
                                <!-- <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.nameSchool.required && submitted">
                                    Vui lòng nhập tên trường
                                </span> -->
                            </div>
                            <div class="row col-md-12">
                                <label for="nameTeacher" class="title-label">Tên giáo viên:</label>
                                <b-form-input v-model="form.nameTeacher" id="nameTeacher" type="text"
                                    placeholder="Nhập tên giáo viên" autocomplete="off" class="form-control" />
                                <!-- <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.nameTeacher.required && submitted">
                                    Vui lòng nhập tên giáo viên
                                </span> -->
                            </div>
                            <div class="row col-md-12">
                                <label for="name" class="title-label">Mô tả:</label>
                                <b-form-textarea id="textarea" v-model="form.description" placeholder="Nhập mô tả"
                                    rows="3"></b-form-textarea>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-6">
                                    <div class="display-flex-center cg-025r">
                                        <label for="countQuestion" class="title-label mb-0">Tổng số câu:</label>
                                        <b-form-input v-model="form.listQuestion.length" id="countQuestion"
                                            type="number" placeholder="" autocomplete="off" class="form-control w-30px"
                                            readonly />
                                        <div>&nbsp;câu</div>
                                    </div>
                                    <!-- <span class="error display-block color-err font-size-14 text-left"
                                        v-if="!$v.form.countQuestion.required && submitted">
                                        Vui lòng nhập tổng số câu
                                    </span> -->
                                </div>
                                <div class="col-md-6">
                                    <div class="display-flex-center cg-025r">
                                        <label for="countPoint" class="title-label mb-0">Tổng điểm:</label>
                                        <b-form-input v-model="form.countPoint" id="countPoint" type="number"
                                            placeholder="" autocomplete="off" class="form-control w-30px" />
                                        <div>&nbsp;điểm</div>
                                    </div>
                                    <span class="error display-block color-err font-size-14 text-left"
                                        v-if="!$v.form.countPoint.required && submitted">
                                        Vui lòng nhập tổng điểm
                                    </span>
                                </div>
                            </div>
                            <div class="row col-md-12 mt-2">
                                <label for="name"></label>
                                <button type="button" @click="handleDividePointsEqually"
                                    class="btn btn-main border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                                    :disabled="isLoading">
                                    Chia đều điểm
                                </button>
                            </div>
                            <div class="row">
                                <div class="col-md-12 wrap-btn">
                                    <button type="button" @click="randomExcercise"
                                        class="btn btn-main border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                                        :disabled="isLoading">
                                        Trộn câu
                                    </button>
                                </div>
                                <div class="col-md-12 wrap-btn">
                                    <button type="button"
                                        class="btn btn-main border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                                        :disabled="isLoading">
                                        Xem trước
                                    </button>
                                </div>
                                <div class="col-md-12 wrap-btn">
                                    <button type="submit"
                                        class="btn btn-main border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                                        :disabled="isDisabledButtonSave">
                                        Lưu
                                    </button>
                                </div>
                                <div class="col-md-12 wrap-btn">
                                    <button type="button" @click="handleSaveAndAssign"
                                        class="btn btn-main border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                                        :disabled="isLoading">
                                        Lưu và Giao bài
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form_action display-flex justity-content-space-between">
                        <button type="button"
                            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading" @click="handleHideModal">
                            Hủy
                        </button>

                    </div>
                </div>
            </b-form>

        </b-modal>
        <ModalCreateAndAssignExcercise :status="1" :item="dataSave" :type="3" v-if="isShowModalAssignExcercise"
            @closeModal="closeModalAssignExcercise" @handleAssignSuccess="handleAssignSuccess" />
        <ModalDialogCloseQuestion v-if="isShowDialogCloseQuestion" @closeModal="closeDialogCloseQuestion"
            @closeModalComfirmQuestion="handleHideModal" />
        <ModalInstructionPrepareQuestion @closeModal="isOpenModalInstructionPrepareQuestion = false"
            v-if="isOpenModalInstructionPrepareQuestion" />
    </div>
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import { getAllTypeFilter, getAllClassFilter } from './../../../_api/'
import { saveExcerciseClassSchool } from './../../../_api/LessonClassSchoolServices'
import VueCkeditor from 'vue-ckeditor2';

import ModalCreateAndAssignExcercise from './ModalCreateAndAssignExcercise.vue'
import ModalDialogCloseQuestion from './ModalDialogCloseQuestion'
import ModalInstructionPrepareQuestion from './ModalInstructionPrepareQuestion'
import draggable from 'vuedraggable'
import PreviewQuestion from '@/modules/question/preview-question-excercise-thieu/PreviewQuestion.vue'
import store from '@/modules/question/preview-question-excercise-thieu/_store'
import { STORE_KEY as STORE_KEY_QUESTION, TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL } from '@/modules/question/preview-question-excercise-thieu/_store/constants'
export default {
    name: "ModalComfirmQuestionBank",
    components: {

        ModalCreateAndAssignExcercise,
        ModalDialogCloseQuestion,
        draggable,
        PreviewQuestion,
        ModalInstructionPrepareQuestion
    },
    props: {
        type: {
            type: Number,
            default: 0
        },
        typeUpload: {
            type: Number,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: 0
        },
        listDataQuestion: {
            type: Array,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: []
        },
        dataDetailExcercise: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isDisabledButtonSave: false,
            isShowModalAssignExcercise: false,
            TYPE_RADIO: 'radio',
            TYPE_CHECKBOX: 'checkbox',
            TYPE_TRUE_FALSE_NO: 'answer_t_f_no',
            TYPE_MATH_COL: 'math_col',
            TYPE_FILL_BLANK: 'fill_blank',
            TYPE_FILL_SENTENCE: 'fill_sentence',
            TYPE_SELECT: 'select',
            TYPE_DOWN_ANSWER: 'down_answer',
            TYPE_CIRCLE_ANSWER: 'circle_answer',
            TYPE_X_MARK: 'x_mark_answer',
            TYPE_DRAW_SHAPE_ANSWER: 'draw_shape_answer',
            TYPE_GROUP: 'group',
            TYPE_FILL_INPUT_IMG: 'fill_input_img',
            typeGroup: TYPE_GROUP,
            typeDrawShape: TYPE_DRAW_SHAPE_ANSWER,
            typeDownAnswer: TYPE_DOWN_ANSWER,
            typefillBlank: TYPE_FILL_BLANK,
            typeSelect: TYPE_SELECT,
            typeMatchCol: TYPE_MATH_COL,
            confirmActive: {},
            submitted: false,
            isLoading: false,
            form: {
                id: 0,
                code: '',
                type: 3,
                name: '',
                typeExcercise: 1,
                classId: '',
                subjectId: '',
                minuteExcercise: '',
                nameSchool: '',
                nameTeacher: '',
                description: '',
                countQuestion: '',
                countPoint: '',
                listQuestion: [],
                typeUploadExcercise: this.typeUpload
            },
            listTypeExcercise: [
                { text: 'Bài kiểm tra', value: 1 },
                { text: 'Bài tập', value: 2 },
            ],
            listDataClass: [],
            listDataSubject: [],
            config: {
                toolbar: [
                    ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript']
                ],
                height: 50
            },
            dataSave: null,
            isShowDialogCloseQuestion: false,
            isDisabledMinute: false,
            isOpenModalInstructionPrepareQuestion: false
        }
    },
    validations() {
        return {
            form: {
                name: {
                    required
                },
                classId: {
                    required
                },
                subjectId: {
                    required
                },
                // minuteExcercise: {
                //     required
                // },
                minuteExcercise: { required: requiredIf(() => (this.form.typeExcercise == 1)) },
                countPoint: {
                    required
                }
            }
        }
    },
    watch: {
        'form.classId': 'getTypesFilter',
        'form.typeExcercise': 'handleChangeTypeExcercise'
    },
    created() {
        if (!(STORE_KEY_QUESTION in this.$store._modules.root._children)) {
            this.$store.registerModule(STORE_KEY_QUESTION, store);
        }
    },
    mounted() {
        console.log(this.listDataQuestion)
        this.handleShowModal()
        this.GetAllClass()
        if (this.type == 1) {
            this.form.listQuestion = this.listDataQuestion
        }
        else {

            this.form.listQuestion = []
            for (let i = 0; i < this.listDataQuestion.length; i++) {
                const element = this.listDataQuestion[i];
                this.form.listQuestion.push({ ...element, point: element.point ? element.point : 0 })
            }
        }

        if (this.dataDetailExcercise) {
            this.form.id = this.dataDetailExcercise.id,
                this.form.code = this.dataDetailExcercise.code,
                this.form.type = this.dataDetailExcercise.type,
                this.form.name = this.dataDetailExcercise.name,
                this.form.typeExcercise = this.dataDetailExcercise.typeExcercise,
                this.form.classId = this.dataDetailExcercise.classId,
                this.form.subjectId = this.dataDetailExcercise.subjectId,
                this.form.minuteExcercise = this.dataDetailExcercise.minuteExcercise,
                this.form.nameSchool = this.dataDetailExcercise.nameSchool,
                this.form.nameTeacher = this.dataDetailExcercise.nameTeacher,
                this.form.description = this.dataDetailExcercise.description,
                this.form.countQuestion = this.dataDetailExcercise.countQuestion,
                this.form.countPoint = this.dataDetailExcercise.countPoint
            this.form.typeUploadExcercise = this.dataDetailExcercise.typeUploadExcercise
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },

    },
    methods: {
        handleOnOpenModalInstruction() {
            this.isOpenModalInstructionPrepareQuestion = true
        },
        handleChangeTypeExcercise() {
            if (this.form.typeExcercise == 2) {
                this.isDisabledMinute = true
            }
            else {
                this.isDisabledMinute = false
            }
        },
        randomExcercise() {
            let listData = [...this.form.listQuestion]
            for (var i = listData.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                var temp = listData[i];
                listData[i] = listData[j];
                listData[j] = temp;
            }
            this.form.listQuestion = listData
        },
        changeAnswer(data) {

            for (let i = 0; i < this.form.listQuestion.length; i++) {
                const item = this.form.listQuestion[i];
                if (i == data.indexParent) {
                    for (let j = 0; j < item.answers.length; j++) {
                        const element = item.answers[j];
                        if (j == data.indexAnswer) {
                            element.correct = element.content
                        } else {
                            element.correct = ""
                        }
                    }
                    break
                }

            }
        },
        handleAssignSuccess(id) {
            this.closeModalAssignExcercise()
            this.form.id = id
        },
        closeModalAssignExcercise() {
            this.isShowModalAssignExcercise = false
        },
        closeDialogCloseQuestion() {
            this.isShowDialogCloseQuestion = false
        },
        handleSaveAndAssign() {
            this.submitted = true
            let self = this
            // chuyển correct trong answer từ string sang bool
            if (!this.validateFillAllPointQuestion()) {
                return
            }
            if (!this.validatePointQuestion()) {
                return
            }

            if (!this.$v.$invalid) {
                if (this.form.typeExcercise == 1) {
                    if (this.form.minuteExcercise && parseInt(this.form.minuteExcercise) < 5) {
                        this.$toast.error('Thời gian làm bài phải lớn hơn hoặc bằng 5 phút')
                        return
                    }
                }
                this.dataSave = { ...this.form, minuteExcercise: this.form.minuteExcercise ? this.form.minuteExcercise : 0 }
                this.dataSave.listQuestion = []
                let listDataQuestionConvert = [...this.form.listQuestion]
                let hasTypeDownAnswer = false
                for (let i = 0; i < listDataQuestionConvert.length; i++) {
                    let item = listDataQuestionConvert[i]
                    let question = {
                        id: 0,
                        idClient: item.idClient,
                        questionId: item.questionId,
                        content: item.content,
                        point: item.point,
                        answerContent: item.answerContent,
                        type: item.type,
                        orderNo: 0,
                        answers: []
                    }
                    if (item.type == this.TYPE_DOWN_ANSWER) {
                        hasTypeDownAnswer = true
                    }
                    for (let j = 0; j < item.answers.length; j++) {
                        const answer = item.answers[j];
                        question.answers.push({
                            id: 0,
                            idClientExcerciseQuestion: item.idClient,
                            questionId: item.questionId,
                            answerId: answer.answerId,
                            content: answer.content,
                            correct: answer.correct,
                        })
                    }

                    this.dataSave.listQuestion.push(question)
                }
                if (hasTypeDownAnswer) {
                    this.dataSave.typeUploadExcercise = 2
                }
                this.dataSave.countQuestion = this.form.listQuestion.length
                this.isShowModalAssignExcercise = true
            }

        },

        validateFillAllPointQuestion() {
            for (let i = 0; i < this.form.listQuestion.length; i++) {
                const item = this.form.listQuestion[i];
                if (!item.point) {
                    this.$toast.error('Vui lòng nhập đầy đủ điểm các câu hỏi')
                    return false
                }
            }
            return true
        },
        validatePointQuestion() {
            let countPointQuestion = 0
            for (let i = 0; i < this.form.listQuestion.length; i++) {
                const item = this.form.listQuestion[i];
                if (item.point) {
                    countPointQuestion += parseFloat(item.point)
                }
            }

            let countPoint = parseFloat(this.form.countPoint ? this.form.countPoint : 0)
            const epsilon = 0.1;
            if (Math.abs(countPointQuestion - countPoint) > epsilon) {
                this.$toast.error('Tổng điểm các câu hỏi không bằng tổng điểm của bài thi')
                return false
            }
            return true
        },
        handleSave() {

            this.submitted = true
            let self = this
            // chuyển correct trong answer từ string sang bool
            if (!this.validateFillAllPointQuestion()) {
                return
            }
            if (!this.validatePointQuestion()) {
                return
            }
            if (!this.$v.$invalid) {
                if (this.form.typeExcercise == 1) {
                    if (this.form.minuteExcercise && parseInt(this.form.minuteExcercise) < 5) {
                        this.$toast.error('Thời gian làm bài phải lớn hơn hoặc bằng 5 phút')
                        return
                    }
                }
                this.isDisabledButtonSave = true
                this.dataSave = { ...this.form, minuteExcercise: this.form.minuteExcercise ? this.form.minuteExcercise : 0 }
                this.dataSave.listQuestion = []
                let listDataQuestionConvert = [...this.form.listQuestion]
                let hasTypeDownAnswer = false
                for (let i = 0; i < listDataQuestionConvert.length; i++) {
                    let item = listDataQuestionConvert[i]
                    let question = {
                        id: 0,
                        idClient: item.idClient,
                        questionId: item.questionId,
                        content: item.content,
                        point: item.point,
                        answerContent: item.answerContent,
                        type: item.type,
                        orderNo: 0,
                        answers: []
                    }
                    if (item.type == this.TYPE_DOWN_ANSWER) {
                        hasTypeDownAnswer = true
                    }
                    for (let j = 0; j < item.answers.length; j++) {
                        const answer = item.answers[j];
                        question.answers.push({
                            id: 0,
                            idClientExcerciseQuestion: item.idClient,
                            questionId: item.questionId,
                            answerId: answer.answerId,
                            content: answer.content,
                            correct: answer.correct,
                        })
                    }

                    this.dataSave.listQuestion.push(question)
                }
                if (hasTypeDownAnswer) {
                    this.dataSave.typeUploadExcercise = 2
                }
                this.dataSave.countQuestion = this.form.listQuestion.length
                //
                saveExcerciseClassSchool(this.dataSave).then(res => {
                    if (res && res.data && !res.errors) {
                        if (this.form.id == 0) {
                            self.$toast.success('Thêm đề kiểm tra thành công')
                            //this.handleDone()
                            this.form.id = res.data.id
                        }
                        else {
                            self.$toast.success('Cập nhật đề kiểm tra thành công')
                        }
                        this.isDisabledButtonSave = false
                        console.log(res.data.id)
                    }
                })
            }

        },
        handleOnInputPoint(e, data) {
            let countPointQuestion = 0
            for (let i = 0; i < this.form.listQuestion.length; i++) {
                const item = this.form.listQuestion[i];
                if (item.point) {
                    countPointQuestion += parseFloat(item.point)
                }
            }
            let countPoint = parseFloat(this.form.countPoint ? this.form.countPoint : 0)

            if (countPointQuestion > countPoint) {
                this.$toast.error('Điểm không được lớn hơn tổng điểm bài thi, vui lòng nhập tổng điểm trước khi set điểm tại từng câu')
                data.point = 0
            } else {

                this.form.countPoint = countPoint
            }

        },
        handleDividePointsEqually() {
            //hàm chia đều điểm
            //lấy điểm cần
            let pointDevide = parseFloat(this.form.countPoint) / parseFloat(this.form.listQuestion.length)

            for (let i = 0; i < this.form.listQuestion.length; i++) {
                let item = this.form.listQuestion[i];
                item.point = pointDevide
            }
            console.log(this.form.listQuestion)
        },
        handleEditQuestion(question) {
            for (let i = 0; i < this.form.listQuestion.length; i++) {
                const item = this.form.listQuestion[i];
                if (question.questionId == item.questionId) {
                    item.isEdit = true
                    break
                }
            }
        },
        handleAddAnswerQuestion(questionItem) {
            for (let i = 0; i < this.form.listQuestion.length; i++) {
                const item = this.form.listQuestion[i];
                if (questionItem.questionId == item.questionId) {
                    item.answers.push({
                        id: 0,
                        questionId: questionItem.questionId,
                        answerId: this.generateUUID(),
                        name: '',
                        correct: ''
                    })
                    break
                }
            }
        },
        handleDeleteQuestion(itemDelete) {
            for (let i = 0; i < this.form.listQuestion.length; i++) {
                const item = this.form.listQuestion[i];
                if (item.questionId == itemDelete.questionId) {
                    this.form.listQuestion.splice(i, 1)
                    break
                }
            }
        },

        generateUUID() { // Public Domain/MIT
            var d = new Date().getTime();
            if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
                d += performance.now(); //use high-precision timer if available
            }
            var newGuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });

            return newGuid;
        },
        getTypesFilter() {
            let self = this
            self.listDataSubject = []
            getAllTypeFilter({ classId: this.form.classId }).then(res => {

                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({ value: item.subjectId, text: item.name })
                    }
                }
            })
        },
        GetAllClass() {
            let self = this
            self.listDataClass = []
            getAllClassFilter({}).then(res => {

                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        self.listDataClass.push({ value: item.classId, text: item.name })
                    }
                }
            })
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-confirm-question-bank'].show()
        },
        handleOnClose() {
            if (this.form.id > 0) {
                this.handleHideModal()
                return
            }
            this.isShowDialogCloseQuestion = true
        }

    }
}
</script>
<style lang="scss" scoped>
.justify-content-space-between {
    justify-content: space-between;
}

.title-header {
    color: #2032b5;
}

.title-label {
    font-size: 15px;
}

.point-question {
    width: 35px;
}

.required {
    color: red;
}

.wrap-left {
    height: 80vh;
    overflow: auto;
}

.wrap-create-answer {
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer;

    .icon-plus {
        width: 20px;
        height: 20px;
    }
}

.wrap-question-answer {
    padding: 10px;
    border: 2px solid #4e69c8;
    border-radius: 15px;
    margin-top: 10px;
    position: relative;

    .icon-delete {
        width: 15px;
        height: 15px;
        position: absolute;
        right: 10px;
        cursor: pointer;
    }
}

.margin-top-10 {
    margin-top: 10px;
}

.wrap-btn .btn-main {
    width: 50%;
}

.wrap-btn {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}

.modal-content {
    background-color: red;
}

.modal-confirm-question-bank {
    padding: 20px;
    background-color: white;
    border-radius: 15px;
    // custom size modal
    max-width: 90%;
    height: 95vh;
    overflow: scroll;
    //height: 100%;
    top: 2%;
    left: 5%;
    right: 0;
    position: fixed;
    z-index: 100000;
    margin: 0px;

    .modal__actions {

        .btn-delete {
            color: white;
            background: #fe0201;
            padding: 5px 20px 5px 20px;
            border-radius: 15px;
            font-family: sans-serif;
        }

        .btn-cancel {
            margin-right: 10px;
            font-family: sans-serif;
        }
    }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}

.icon-close {
    cursor: pointer;
    width: 15px;
    float: right;
    top: -45px;
    position: relative;
}

@media (min-width: 968px) {
    .b-col-md-6 {
        -ms-flex: 0 0 50%;
        -webkit-box-flex: 0;
        flex: 0 0 50%;
        max-width: 50%;
    }
}

@media (min-width: 1192px) {
    .b-col-lg-7 {
        -ms-flex: 0 0 58.333333%;
        -webkit-box-flex: 0;
        flex: 0 0 58.333333%;
        max-width: 58.333333%;
    }

    .b-col-lg-5 {
        -ms-flex: 0 0 41.666667%;
        -webkit-box-flex: 0;
        flex: 0 0 41.666667%;
        max-width: 41.666667%;
    }

    .b-col-lg-6 {
        -ms-flex: 0 0 50%;
        -webkit-box-flex: 0;
        flex: 0 0 50%;
        max-width: 50%;
    }
}

@media (min-width: 1400px) {
    .b-col-xl-8 {
        -ms-flex: 0 0 66.666667%;
        -webkit-box-flex: 0;
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
    }

    .b-col-xl-4 {
        -ms-flex: 0 0 33.333333%;
        -webkit-box-flex: 0;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }

    .b-col-xl-3 {
        -ms-flex: 0 0 25%;
        -webkit-box-flex: 0;
        flex: 0 0 25%;
        max-width: 25%;
    }
}

.margin-10 {
    margin-top: 10px;
    margin-bottom: 10px;
}

.cg-025r {
    column-gap: 0.25rem;
}
</style>